var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoMeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.794 12.2145C3.794 12.2145 3.79 12.2165 3.788 12.2185C3.79 12.2165 3.79 12.2145 3.792 12.2125L3.794 12.2145ZM14.453 6.83552C13.455 9.09252 9.658 10.7265 7.655 10.4735C7.359 10.7685 6.564 11.5635 6.258 11.8695C7.788 14.5965 3.46 16.4455 2.546 13.4615C-0.443 12.5435 1.413 8.21752 4.136 9.74852C4.439 9.44652 5.227 8.65852 5.518 8.36652C5.233 6.12352 7.478 1.01352 10.654 1.23552C12.996 1.16752 15.927 4.62152 14.452 6.83552H14.453ZM13.577 6.34252C14.601 4.34552 11.463 1.44052 9.651 2.45252C8.432 3.70252 11.703 7.57052 13.577 6.34252ZM6.474 10.2405C6.081 10.0845 5.92 9.93052 5.763 9.53752L4.05 11.2495C3.92 10.4595 2.858 10.1625 2.313 10.7415C1.352 11.7105 2.82 13.1785 3.789 12.2175C3.124 12.8375 3.634 14.0315 4.527 13.9995C5.734 14.0185 5.967 12.1875 4.757 11.9565L6.475 10.2395L6.474 10.2405ZM12.689 7.55352C10.711 7.48752 8.483 5.21752 8.411 3.35952C8.22 3.56752 8.033 3.79852 7.853 4.06052C6.071 6.66452 6.503 8.97752 6.733 9.26852C7.026 9.49852 9.337 9.93052 11.941 8.14852C12.221 7.95652 12.47 7.75752 12.689 7.55352ZM11.517 3.73852C10.506 3.85952 10.933 5.16452 11.728 5.14252C12.705 5.09452 12.386 3.71352 11.517 3.73852Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMeat);
export default __webpack_public_path__ + "static/media/ico_meat.35bcee340ec587656462a071915fd1be.svg";
export { ForwardRef as ReactComponent };